import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './pages/admin/admin-css/admin-overall-css.css';
import './pages/auth/auth-forms.css';
import App from './App';

// Suppress ResizeObserver loop warnings
const originalError = console.error;
console.error = (...args) => {
  if (
    typeof args[0] === 'string' &&
    args[0].includes('ResizeObserver loop completed with undelivered notifications')
  ) {
    return;
  }
  originalError.call(console, ...args);
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
